import { t as a } from "./index813.mjs";
var e = a, i = Math.max, o = Math.min, v = function(n, r) {
  var t = e(n);
  return t < 0 ? i(t + r, 0) : o(t, r);
};
export {
  v as t
};
